import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '123px',
  },
  label: {
    marginLeft: 8,
  },
}))
